import { render, staticRenderFns } from "./Manufacturing_Capabilities_Section.vue?vue&type=template&id=85674d06&scoped=true"
import script from "./Manufacturing_Capabilities_Section.vue?vue&type=script&lang=js"
export * from "./Manufacturing_Capabilities_Section.vue?vue&type=script&lang=js"
import style0 from "./Manufacturing_Capabilities_Section.vue?vue&type=style&index=0&id=85674d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85674d06",
  null
  
)

export default component.exports